const lang = {
  en: {
    pageIndex: {
      intro: 'Learn about Cubicost Cloud',
      active: {
        title: 'Cubicost Cloud - Truly fit actual usage scenarios',
        one: {
          scene: 'Scenario 1 [Office]',
          firstRole: 'QS',
          firstRoleDesc: 'Upload your projects and cost data easily. Reuse enterprise and individual data to build up rates and generate high quality cost plan rapidly. Save time and improve quality greatly.',
          secondRole: 'Supervisor',
          secondRoleDesc1: 'Store and manage all projects in the cloud. Ensure bank-level encryption with Alibaba Cloud. More secure and less expensive than disks. Avoid the costs of storage disks.',
          secondRoleDesc2: 'Accumulate and review data rapidly. Preview construction cost projects easily with no dongle.',
          secondRoleDesc3: 'High quality cost plan empowers your tendering. Increase both progress and quality, thus improving enterprises’ competitiveness.'
        },
        two: {
          scene: 'Scenario 2 [Home]',
          firstRole: 'Employee',
          firstRoleDesc: 'When you want to use construction cost software at home, you can directly open the cloud project, edit it and sync the changes automatically. No need to copy files back and forth with a USB disk. No messy files.',
          secondRole: 'Manager',
          secondRoleDesc1: 'Preview your construction cost projects rapidly on web. No need for dongle or software installation.',
          secondRoleDesc2: 'Preview your construction cost projects rapidly on phone, and conduct your reviews and comments.'
        },
        three: {
          scene: 'Scenario 3 [Construction Site]',
          firstRole: 'Employee A',
          firstRoleDesc: 'View your construction cost project files directly on phone, add comments, and make modifications when back to the office.',
          secondRole: 'Employee B',
          secondRoleDesc1: 'View and consult information on phone, and get to know the latest governmental files.',
          secondRoleDesc2: 'Your boss or colleagues want to know the construction costs? View them on phone. One-click to share.'
        }
      },
      ad: 'Start working easily with Cubicost Cloud now',
      tel: '86-4000-166-166'
    },
    login: {
      title: 'Welcome to Cubicost Cloud',
      userName: 'Account',
      validateEmpty: 'Please enter your account and password',
      validateRules: 'Please enter the correct email address.',
      password: 'Password',
      forget: 'Forget Password?',
      send: 'Log In',
      fail: 'Login failed.',
      register: 'Register',
      space: 'Personal Space Capacity',
      enter: 'Enter Cubicost Cloud', // 文案过长，按钮内跳行，需特殊处理
      logout: 'Log Out',
      loginAgain: 'The current account is ineffective. Please log in again.',
      registerLink: 'https://account.global.glodon.com/register',
      forgetLink: 'https://account.global.glodon.com/forgetInit',
      logoutConfirm: 'This operation will stop the upload task. Are you sure you want to perform it?',
      logoutFail: 'Failed to log out the account system.'
    },
    guide: {
      next: 'Next',
      experience: 'Experience Now'
    },
    header: {
      welcome: 'Hello',
      admin: 'I am Administrator',
      productCenter: 'Product Center',
      user: {
        enterpriseLink: 'https://account.global.glodon.com/info',
        securityLink: 'https://account.global.glodon.com/security/emailbind',
        space: 'Personal Space Capacity',
        userCenter: 'User Center',
        safeCenter: 'Security Center',
        help: 'Help Document',
        history: 'Upload History',
        logout: 'Log Out'
      }
    },
    sideBar: {
      engineering: 'Project Management',
      personSpace: 'Personal Space Capacity',
      recycle: 'Recycle Bin'
    },
    upload: {
      tooMore: 'Too many files. You can upload 100 files at most in one time.',
      limitSize: 'The file size cannot exceed 500MB. Please select a file less than 500MB to upload.',
      buySpace: 'The capacity of enterprise shared space is not enough. Please contact local sales to buy capacity package.',
      spaceSizeValidate: 'The capacity of personal space is not enough. Please organize your personal space.',
      expanded: 'The capacity of enterprise shared space is not enough. Please contact your administrator to enlarge the space.',
      cancelUpload: 'Are you sure you want to cancel the uploading?',
      title: 'Uploading files and data...',
      name: 'Project File',
      dataFile: 'Data File',
      size: 'Size',
      status: 'State',
      uploading: 'Uploading...',
      uploadFinish: 'Upload completed.',
      uploadSuccess: 'Upload succeeded.',
      uploadFail: 'Upload failed.',
      confirmDialog: {
        title: 'There is one or more files with the same name. Do you want to replace it?',
        confirm: 'Replace',
        add: 'Add',
        cancel: 'Skip'
      },
      closeDialog: {
        width: 400,
        title: 'After closing the upload list, you can view the projects in uploading state in Upload History. ',
        desc: 'Do not prompt me again'
      },
      errorTipsTitle: 'Does not support importing this type of project files.',
      errorTipsValidate: 'Does not support importing this type of project files. Supported files: GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6',
      buy: 'Buy Package'
    },
    uploadRecord: {
      back: 'Go back to homepage',
      uploading: 'Uploading...',
      uploaded: 'Uploaded',
      engineeringRecord: 'Uploaded Log',
      column: {
        name: 'Name',
        uploadTime: 'Time Uploaded',
        size: 'Project Size',
        status: 'Status',
        desc: 'Note'
      },
      notEngineeringRecord: 'No upload log for project.',
      notItemRecord: 'No upload log for BQ.',
      notGroupRecord: 'No upload log for component.',
      serviceError: 'Server exception.'
    },
    pagination: {},
    container: {
      recycle: {
        reduction: 'Restore',
        delete: 'Delete Permanently',
        deleteAll: 'Empty Recycle Bin',
        emptyText: 'No file.',
        contextMenu: {
          user: 'Compiler',
          fileType: 'File Type',
          budget: 'Conceptual Estimate',
          estimate: 'Preliminary Estimate',
          settlement: 'Final Account',
          reviewed: 'Review',
          other: 'Others',
          engineering: 'Project Type',
          construct: 'Structure Type',
          item: 'BQ',
          quota: 'Norm',
          nothing: '[Null]'
        },
        reductionDialog: {
          title: 'Please select your file',
          success: 'Restore succeeded.',
          fail: 'Restore failed.'
        },
        deleteAllDialog: {
          title: 'Are you sure you want to empty the Recycle Bin?',
          desc: 'You cannot restore it after you empty the Recycle Bin.',
          confirm: 'Confirm Empty',
          noPower: 'You have no permission to empty the Recycle Bin. Please contact project owner.',
          nothing: 'No file to empty.',
          success: 'Empty recycle bin succeeded.',
          fail: 'Empty recycle bin failed.'
        },
        deleteDialog: {
          title: 'Are you sure you want to delete it permanently?',
          desc: 'You cannot restore the file after you delete it permanently.',
          confirm: 'Confirm Delete',
          noPower: 'You have no permission to delete permanently. Please contact project owner.',
          success: 'Delete succeeded.',
          fail: 'Delete failed.'
        }
      },
      upload: 'Upload',
      uploadFile: 'Upload File',
      uploadFolder: 'Upload Folder',
      addFolder: 'New Folder',
      refresh: 'Refresh',
      download: 'Download',
      downloading: 'Downloading file...',
      downloadingCloudFiles: 'Downloading cloud file…',
      uploadingData: 'Uploading data…',
      uploadingFiles: 'Uploading file…',
      operating: 'Processing…',
      browserValidate: 'Viewing model is not supported by the current browser. Please use Google Chrome to view models.',
      downloadChrome: 'Download Google Chrome',
      downloadFail: 'Download failed.',
      noPowerToDownload: 'You do not have the permission to access enterprise space. Please contact the administrator to get the permission.',
      adminAccount: 'Administrator Account: {0}',
      someNeedPower: 'The permission to access enterprise space is needed for some projects. Please contact the administrator to get the permission.',
      copyToCompanySuccess: 'Copy to Enterprise Shared Space succeeded.',
      copyToCompanyFail: 'Copy to Enterprise Space failed.',
      folderIsEmpty: 'The folder is empty.',
      exchange: 'Save to My Space',
      copyToCompanySpace: 'Copy to Enterprise Shared Space',
      drag: 'Drag your file into the box',
      report: 'Multi-Project Report',
      xtModel: 'Collaborative  Modeling',
      createProject: 'New Project',
      cancelPower: 'Remove Permission',
      addPower: 'Grant Permission',
      export: 'Export',
      excelExport: 'Export to Excel',
      interfaceExport: 'Export to Platform Interface',
      delete: 'Delete',
      move: 'Move to',
      preview: 'Preview',
      model: 'View Model',
      modelTitle: 'Preview Project',
      share: 'Share',
      rename: 'Rename',
      editFail: 'Modify failed.',
      sort: 'Sort',
      engineeringName: 'Project Name',
      confirmText: 'OK',
      confirmDeleteText: 'Confirm Delete',
      cancelText: 'Cancel',
      queryFail: 'Failed to get data.',
      saveSuccess: 'Save succeeded.',
      saveFail: 'Save failed.',
      operateFail: 'The system folder cannot be edited.',
      folderAlreadyExist: 'The folder already exists.',
      addFolderFail: 'Failed to create folder.',
      fileNameEmpty: 'The file name cannot be empty.',
      fileNameValidate: 'The file name cannot contain the following characters: \\ / : * ? " < > $ |, and cannot start or end with period (.).',
      fileNameTooLong: 'The length of file name cannot exceed 83 characters.',
      deleteDialog: {
        title: 'Are you sure you want to delete the file?',
        desc: 'You can use the Recycle Bin to restore the deleted file.',
        tips: 'You cannot retrieve it after deletion.',
        success: 'Delete succeeded.',
        fail: 'Delete failed.'
      },
      moveDialog: {
        moveFiles: 'Moving file',
        space: 'My Space',
        moving: 'Moving...',
        movingFiles: 'Moving file...',
        success: 'Move succeeded.',
        fail: 'Move failed.'
      },
      shareDialog: {
        expiryDate: 'Effective Period of Link',
        oneDay: '1 day',
        sevenDay: '7 days',
        longTime: 'Permanent',
        effective1: 'Effective within 1day',
        effective7: 'Effective within 7days',
        effectiveLong: 'Effective permanently',
        confirm: 'Create Link',
        time: 'Time',
        copy: 'Copy Link',
        success: 'Share succeeded.',
        fail: 'Share failed. Please try again later.',
        copySuccess: 'The link is successfully copied. You can share your project now.',
        copyFail: 'This browser does not support auto copy.'
      },
      copyDialog: {
        tips: 'Are you sure you want to copy the file to the Enterprise Shared Space?',
        tipsRed: 'To avoid long waiting time, please operate on small-number files in one time.'
      },
      allFiles: 'All Files',
      valuationDoc: 'Costing File',
      meteringDoc: 'Quantification File',
      comeBack: 'Up to parent',
      search: {
        placeholder: 'Please input name',
        button: 'Search'
      },
      column: {
        selectAll: 'Select All',
        selected: 'Selected {number} files/folders',
        name: 'Name',
        type: 'Type',
        region: 'Region',
        updateTime: 'Time Updated',
        editTime: 'Time Modified',
        createTime: 'Time Created',
        size: 'Project Size',
        shareTime: 'Time Shared',
        remainingTime: 'Time Remaining',
        sharePerson: 'Shared by',
        failure: 'Ineffective',
        valuation: 'Costing',
        metering: 'Quantification',
        meteringXT: 'Quantification Collaboration'
      },
      emptyText: 'No project is uploaded.',
      receive: {
        emptyText: 'No project files is received.'
      },
      operateTip: {
        other: 'Others',
        operateFile: 'The current file/folder is being edited by <em style="color: #1c6ccd;">{0}</em>.To prevent files from being overwritten or lost, you cannot perform this operation now. Please try again later.',
        operateParentFile: 'The parent folder of the current file/folder <em style="color: #1c6ccd;">{0}</em> is being edited by <em style="color: #1c6ccd;">{1}</em>.To prevent files from being overwritten, you cannot perform this operation now. Please try again later.',
        operateChildFile: 'The file/folder <em style="color: #1c6ccd;">{0}</em> of the current folder is being edited by <em style="color: #1c6ccd;">{1}</em>. To prevent files from being lost, you cannot perform this operation now. Please try again later.'
      }
    },
    footer: {
      aboutLink: 'https://account.global.glodon.com/about',
      contactLink: 'https://account.global.glodon.com/contact',
      about: 'About Us',
      contact: 'Contact Us',
      protocol: 'User Agreement',
      privacy: 'Privacy Policy',
      record: '© 2020 Glodon'
    },
    modelBrowsing: {},
    preview: {
      toLarge: 'The picture size exceeds 10MB. Please view it after downloading.',
      parseFail: 'An error occurs when resolving model.',
      parsing: 'Resolving model…',
      later: 'You can view the file after <span class="bim_wait_date">5~20 minutes</span> since uploading.',
      formatWarning: 'Previewing this type of files is not supported temporarily.',
      regionWarning: 'Previewing projects in this region is not supported temporarily. We are now developing it. Stay tuned.'
    },
    message: {
      myNews: 'My Message',
      shareMessage: 'Share',
      commentMessage: 'Comment',
      projectMessage: 'Project Info',
      load: 'Loading messages...',
      image: 'Picture',
      comment: 'The project has comments.',
      receiveLink: 'Received Share Link',
      noMessage: 'You have not got any message yet.',
      loadFail: 'Failed to loading messages.',
      openMessageCenter: 'Open Message Center',
      day: 'day',
      hours: 'hours',
      expiryDate: 'Remaining Effective Time',
      messageCenter: 'Message Center',
      allShare: 'Share All',
      myShare: 'Message Shared by Me',
      shareToMe: 'Message Shared with Me',
      mark: 'Mark as Read',
      markAll: 'Mark All as Read',
      selectNone: 'No notification is selected.',
      tips: 'Are you sure you want to delete the notification?',
      tipsRed: 'You cannot retrieve it after deletion.',
      shareByMeLongWord: 'I have shared <span class="blue">{0}</span>, and generated the share link: <span class="blue">{1}</span>',
      shareWithMeLongWord: 'Received <span class="blue">{0}</span> shared by <span class="blue">{1}</span>.',
      MyReceiveLink: 'I have got a share link: <span class="blue">{0}</span>',
      shareToOthers: 'I have shared <span class="blue">{1}</span> with <span class="blue">{0}</span>.',
      openFile: 'Open File',
      back: 'Return to Platform',
      alreadyDelete: 'The shared project is deleted.',
      alreadyFailure: 'The shared project is ineffective.'
    }
  }
}
export default lang
